

import { lazy } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { Navigate } from "react-router-dom";

const Role = lazy(() => import("../components/role"));
const RoleList = lazy(() => import("../components/roleList"));

const roleRoute = {
  icon: SettingsIcon,
  name: "Settings",
  before: "Role",
  path: "settings",
  link: "/settings",
  index: 25,
  children: [
    {
      path: "roles",
      element: <RoleList />,
      name: "Roles",
      link: "settings/roles",
      permission: "Roles-Read",
      icon: AdminPanelSettingsIcon,
      index: 2,
    },
    {
      path: "roles/create",
      element: <Role />,
    },
    {
      path: "roles/:id",
      element: <Role />,
    },
    {
      path: "",
      element: <Navigate to="users" replace />,
    },
  ],
};
export default roleRoute;
